import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faHourglass} from '@fortawesome/free-solid-svg-icons';
import ribbon from './../assets/ribbon2.png'
import PropTypes from 'prop-types';

const PricingCard = ({ heading, price, duration, includes, rate, additionalHoursRate}) => {
  return (
    <div className="relative w-full max-w-sm p-6 py-12 bg-emerald-50 border border-gray-200 rounded-xl shadow-md mx-auto cursor-pointer on-hover:shadow-xl">
      {/* Ribbon */}
        <img
          src={ribbon}
          alt="Ribbon"
          className="absolute top-0 right-4 w-16 h-16"
        />

      {/* Heading */}
      <h5 className="mt-10 mb-4 text-xs sm:text-sm md:text-lg lg:text-xl  font-semibold text-gray-700 text-center">{heading}</h5>   
      {/* Price */}
      <div className="flex items-baseline justify-center text-gray-900 mb-12">
        <span className="text-lg sm:text-xl md:text-3xl lg:text-4xl font-bold tracking-tight">${price}</span>
        <span className="ms-1 text-xs sm:text-sm md:text-lg font-medium text-gray-700">/{duration}</span>
      </div>
      
      {/* Features */}
      <ul role="list" className="space-y-4 px-2">
        <li className="flex items-center">
          <FontAwesomeIcon icon={faClock} className="flex-shrink-0 w-5 h-5 text-teal-500 " />
          <span className="text-xs sm:text-sm md:text-base font-medium leading-tight text-gray-600 ms-3">{includes}</span>
        </li>
        {rate!=="" && <li className="flex items-center">
          <FontAwesomeIcon icon={faHourglass} className="flex-shrink-0 w-5 h-5 text-teal-500" />
          <span className="text-xs sm:text-sm md:text-base font-medium leading-tight text-gray-600 ms-3">{rate}</span>
        </li>}
        {/* <li className="flex items-center">
          <FontAwesomeIcon icon={faPlus} className="flex-shrink-0 w-5 h-5 text-teal-500" />
          <span className="text-xs lg:text-sm font-medium leading-tight text-gray-600 ms-3">{additionalHoursRate}</span>
        </li> */}
      </ul>
    </div>
  );
};

PricingCard.propTypes = {
  heading: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  duration:PropTypes.string.isRequired,
  includes: PropTypes.string.isRequired,
  rate: PropTypes.string.isRequired,
  additionalHoursRate: PropTypes.string.isRequired,  
};

export default PricingCard;
